export const stepWizardStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.steps-wizard': {
    height: '100%',
  },
  '.steps-wizard:after': {
    content: '" "',
    clear: 'both',
    display: 'block',
  },
  '.step-content-container': {
    borderLeft: `1px solid ${palette.neutralQuaternaryAlt}`,
    paddingTop: '20px',
    paddingLeft: 0,
    paddingBottom: '64px',
    minHeight: '100%',

    '& div[data-step-status="done"], div[data-step-status="pending"]': {
      padding: 0,
    },

    '& .step-footer[data-step-status="done"], .step-footer[data-step-status="pending"]': {
      display: 'none',
    },
  },
  '.steps-wizard .steps-wizard__title, .step-body .step-page-title': {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '27px',
    marginLeft: 32,

    '& span[role="heading"][tabindex="-1"]': {
      outline: 'none',
    },
  },
  '.step-content-container .steps-wizard__description': {
    marginTop: '0px',
  },
  '.step-content-container>.action-container': {
    width: '100%',
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '32px',
    marginLeft: '0 !important',
    borderTop: `1px solid ${palette.neutralQuaternaryAlt}`,
    bottom: 0,
    position: 'absolute',
  },

  '.step-content-container .action-container .btn': {
    marginRight: 12,
  },

  '.step-content-container .action-container .btn-back': {
    marginRight: 38,
  },

  '.step-indicator-container': {
    marginTop: '27px',
    paddingLeft: 20,
  },
  '.step-vertical-divider': {
    marginLeft: '7px',
    top: '16px',
    borderLeft: '2px solid #EBEBEB',
    height: '39px',
    marginBottom: '3px',
    marginTop: '3px',
  },
  '.step-indicator': {
    /* position: 'absolute', */
    width: '16px',
    height: '16px',
    left: '0px',
    top: 'calc(50% - 16px/2)',

    fontFamily: 'Fabric MDL2 Assets',
    fontSize: '16px',
    lineHeight: '16px',
    /* identical to box height */
    flex: [0, 1, 'auto'],
    alignItems: 'center',
    borderRadius: '50%',
  },

  '.step-header[data-step-status=active] .step-indicator': {
    backgroundColor: '#C0DEF6',
    fontWeight: 600,
  },
  '.step-header[data-step-status=done] .step-indicator': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
    fontSize: 16,
  },
  '.step-header[data-step-status=done] .step-indicator:before': {
    content: '"\\EC61"',
  },
  '.step-header[data-step-status=pending] .step-indicator': {
    border: `2px solid ${palette.neutralLight}`,
    boxSizing: 'border-box',

    '& .title': {
      marginTop: -4,
    },
  },
  '.current-step': {
    backgroundColor: '#C0DEF6',
    fontWeight: 600,
  },
  '.not-start-step': {
    border: `2px solid ${palette.neutralLight}`,
    boxSizing: 'border-box',

    '& span.title': {
      marginTop: -4,
    },
  },
  '.completed-step': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
    '&:before': {
      content: '"\\EC61"',
    },
  },
  '.step-indicator .title': {
    position: 'absolute',
    height: '24px',
    left: '28px',
    /* top: 'calc(50% - 24px/2 - 1px)', */
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '20px',
    flex: [0, 1, 'auto'],
    alignItems: 'center',
    color: palette.neutralPrimary,
    marginRight: '20px',
    marginLeft: 20,
    marginTop: -2,
  },
});
